import { Component } from '@angular/core';
import { MessageService } from '../../../../services/messages/email.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-messages',
  imports: [CommonModule],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.css'
})
export class MessagesComponent {
  // adminId: string = 'oADeYs8m9SZ7yNcgLZ27Orr6tGq1'; // Replace with your admin ID or fetch dynamically
  messages: any[] = [];
  errorMessage: string = '';

  constructor(
    private messageService: MessageService,
  ) {}
  ngOnInit(){
    
    this.loadMessages();
  }


  loadMessages() {
    this.messageService.getMessages().subscribe({
      next: (messages) => {
        this.messages = messages;
        this.errorMessage = '';
      },
      error: (err) => {
        this.errorMessage = 'Error loading messages: ' + err.message;
        this.messages = [];
      }
    });
  }

  formatFirestoreTimestamp(timestamp: { seconds: number, nanoseconds: number }): string {
  const milliseconds = timestamp.seconds * 1000 + Math.floor(timestamp.nanoseconds / 1_000_000);
  const date = new Date(milliseconds);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short', // Use 'long' for full month name
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
}
}
